import moment from 'moment'

import Vue from 'vue'

const showToastSuccess = (text, className, action, options) => {
  if (!text) return

  Vue.toasted.success(text, {
    theme: 'bubble',
    position: 'bottom-right',
    className: className || 'custom-toast__success',
    action: action || {
      text: '',
      onClick: (e, toastObject) => {
        toastObject.goAway(0)
      },
    },
    ...options,
  })
}

const showToastError = (text, className, action, options) => {
  if (!text) return

  Vue.toasted.error(text, {
    theme: 'bubble',
    position: 'bottom-right',
    className: className || 'custom-toast__error',
    action: action ? {
      text: '',
      onClick: (e, toastObject) => {
        toastObject.goAway(0)
      },
    } : '',
    ...options,
  })
}

const isoDate = (value) => {
  return moment(value).format("YYYY-MM-DD")
}

const isoDateTime = (value) => {
  return moment(value).format("YYYY-MM-DD HH:mm:ss")
}

const isValidUrl = (string) => {
  try {
    new URL(string)
    
    return true
  } catch (_) {
    return false
  }
}

// The API JSON.parse()s the selected condition and answers a bodiless 400 on failure.
const validateStickerCondition = (form, { isEditing = false } = {}) => {
  const condition = form && form.currentCondition

  if (condition === 'rule') {
    const rule = (form.rule || '').trim()
    if (!rule) {
      return 'Targeting: the Rule tab needs a JSON rule, e.g. {"match":[{"var":"user.providerUserEmail"},"you@ahaslides.com"]} — or switch to User Emails to target specific people.'
    }
    try {
      JSON.parse(rule)
    } catch (err) {
      return `Targeting: Rule must be valid JSON (${err.message}). Example: {"match":[{"var":"user.providerUserEmail"},"you@ahaslides.com"]}`
    }
    return ''
  }

  if (condition === 'emails' && !(form.emails || '').trim()) {
    return 'Targeting: add at least one email (one per line), or switch to Rule.'
  }

  if (condition === 'userIds' && !isEditing) {
    return 'Targeting: User Ids does not match anyone (a known backend bug compares a number against text). Use User Emails or Rule instead.'
  }

  return ''
}

// vue-resource rejects with a Response, not an Error, so `e.message` is undefined.
const describeApiError = (e, fallback) => {
  const body = e && e.body
  const fromBody = body && (body.message || body.error)
  // A serialised Error arrives as the literal "{}", which is worse than the fallback.
  const bodyText = (e && e.bodyText || '').trim()
  const meaningfulBodyText = ['', '{}', '[]', 'null', 'undefined'].indexOf(bodyText) === -1
    ? bodyText
    : ''

  return fromBody || meaningfulBodyText || (e && e.message) || fallback
}

function convertToTimestampTz(dateTimeStr) {
  return moment(dateTimeStr).format()
}

function convertToDateTimeLocal(dateTimeStr) {
  return moment(dateTimeStr).format("YYYY-MM-DDTHH:mm")
}

// AHA-38266: a team gets the Enterprise badge when it has a sales-assisted contract
// flagged "Is Enterprise = Yes". `teamid`/`is_enterprise` are the wire field names —
// Redshift lower-cases result columns but keeps underscores, so `is_enterprise` stays
// as-is (unlike `teamId` → `teamid`). Repeated across the four Team/User views, so it
// lives here.
const hasEnterpriseContract = (salesContracts, teamId) => (
  Array.isArray(salesContracts)
  && salesContracts.some(contract => contract.teamid === teamId && contract.is_enterprise === true)
)

export default {
  isoDate,
  isoDateTime,
  showToastSuccess,
  showToastError,
  isValidUrl,
  validateStickerCondition,
  describeApiError,
  convertToTimestampTz,
  convertToDateTimeLocal,
  hasEnterpriseContract,
}